import React, {
  useRef, Fragment
} from 'react'
import {
  connect
} from 'react-redux'
import {
  useDrag, useDrop
} from 'react-dnd'
import {
  getCardDetailsByCardIdSelector, getBoardDetailsByBoardIdSelector
} from '../../redux/selectors'
import CardView from './cardView'
import {
  CardItemWrapper, CardDisabledContainer
} from './styles'

const IrisCard = React.memo(({
  id, cardDetails, boardDetails, laneId, index,
  moveHoveredCard, isBoardEditing, states
}) => {
  const ref = useRef(null)

  const [{
    isDragging
  }, drag] = useDrag({
    item: {
      type: 'CARD',
      id,
      index,
      laneId,
      cardType: cardDetails?.card_type
    },
    isDragging (monitor) {
      const item = monitor.getItem()
      return id === item.id
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  })

  const [, drop] = useDrop({
    accept: 'CARD',
    hover () {
      moveHoveredCard(index)
    }
  })

  drag(drop(!isBoardEditing && (!boardDetails.settings.board_type ||
    (boardDetails.settings.board_type &&
      boardDetails.settings.board_type !== 'iris')) && ref))

  return (
    <div
      data-card-id={cardDetails.id}
      className='cardItem-wrapper'
      style={{
        opacity: isDragging ? 0 : 1,
        width: isDragging ? '0px' : '250px',
        height: isDragging ? '0px' : 'auto',
        // Inline-block cards otherwise align on text baseline, which shifts when reaction chips appear.
        verticalAlign: 'top'
      }}
    >
      <CardItemWrapper ref={ref} isBoardEditing={isBoardEditing}>
        <CardView
          cardDetails={cardDetails}
          boardDetails={boardDetails}
          states={states}
        />
        {isBoardEditing && <CardDisabledContainer />}
      </CardItemWrapper>
    </div>
  )
})

const mapStateToProps = (state, ownProps) => {
  const cardDetails = getCardDetailsByCardIdSelector(state, ownProps.id)
  const boardDetails =
  getBoardDetailsByBoardIdSelector(state, parseInt(ownProps.boardId))
  return {
    cardDetails,
    boardDetails
  }
}

IrisCard.displayName = 'IrisCard'
export default connect(mapStateToProps)(IrisCard)